<template>
  	<van-nav-bar :title="title" left-arrow @click-left="backFn" class="top_bar" />	
</template>

<script>
export default {
	props: {
		title: String
	},
	data() {
		return {
			
		}
	},	
	methods: {
		backFn() {
			if(window.history.length <= 2) {
				this.$router.push({ name: 'team'})
			}
			else {
				this.$router.go(-1)
			}
		},
	}
}
</script>

<style>
	.van-nav-bar {
		z-index: 10;
	}
</style>


// WEBPACK FOOTER //
// src/views/components/Nav.vue